import React from 'react';
import styled from 'styled-components';

interface Props {
	email: string;
	onRemove: () => void;
	invalid?: boolean;
}

const Chip = styled.span<{$invalid: boolean}>`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	border-radius: 9999px;
	padding: 2px 8px;
	${p => p.theme.sys.font?.detail?.['1']}
	border: ${p => p.theme.sys.size.borderwidth.thin} solid
		${p => (p.$invalid ? p.theme.sys.color.border.error : p.theme.sys.color.border.decorative)};
	background: ${p => p.theme.sys.color.background.disabled['1']};
	color: ${p => (p.$invalid ? p.theme.sys.color.text.semantic.error : p.theme.sys.color.text.content.main)};
`;
const RemoveButton = styled.button`
	margin-left: 2px;
	display: inline-flex;
	height: 16px;
	width: 16px;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: 9999px;
	background: transparent;
	color: currentColor;
	cursor: pointer;
	&:hover {
		background: ${p => p.theme.sys.color.border.decorative};
	}
`;

export function RecipientChip({email, onRemove, invalid = false}: Props) {
	return (
		<Chip $invalid={invalid}>
			{email}
			<RemoveButton type="button" aria-label={`Remove ${email}`} onClick={onRemove}>
				&times;
			</RemoveButton>
		</Chip>
	);
}
